<template>
    <modal @close="closeModalAction" dialog="modal-lg" class="dark-top saveProductChanges" :footer="false" :header="false">
        <!-- <div slot="title">

        </div> -->

        <div slot="body">
            <div class="p-4">
                <h2 class="mb-4 text-center bold">Do you want to replace in all events?</h2>

                <p>
                    Some events may have been <span class="bold">manually edited in the calendar</span>, would you like the following information to be replaced in all events?
                </p>

                <!-- Schedule Changes -->
                <schedule-group-changes :product="getClonedItem" />

                <!-- Radio Buttons -->
                <div class="mb-4 pt-3 mt-3 border-top-light">
                    <radio name="resetAll" v-model="optionSelected" :value="false">
                        <span class="darkest">No, do not replace events edited directly in calendar.</span>
                    </radio>
                    <radio name="resetAll" v-model="optionSelected" :value="true">
                        <span class="darkest">Yes, apply changes to all events.</span>
                    </radio>
                </div>

                <!-- Buttons -->
                <div class="d-flex">
                    <div class="">
                        <button class="btn tertiary" @click="closeModal">Cancel</button>
                    </div>
                    <div class="flexGrow1 text-right">
                        <button class="btn" @click="pressBtn" :disabled="optionSelected == null">Submit</button>
                    </div>
                </div>

            </div>
        </div>
    </modal>
</template>

<script>
import Modal from './Modal'
import {mapActions, mapGetters} from 'vuex'
import scheduleGroupChanges from '@/components/inventory/products/components/scheduleGroupChanges'
export default {
    data: function () {
        return {
            optionSelected: null,
        }
    },
    computed: {
        ...mapGetters([
            'getClonedItem',
            'account'
        ])
    },
    methods: {
        ...mapActions([
            'closeModal',
            'updateItem',
            'clearSelectedItem',
            'flushEvents'
        ]),
        closeModalAction: function () {

        },
        cancelBtn: function () {
            this.closeModal()
        },
        pressBtn: function () {
            this.getClonedItem.resetItemsWhenEditing = this.optionSelected
            this.updateProduct(this.getClonedItem)
        },
        updateProduct: function (form) {
            this.$toasted.info('Saving product');
            this.updateItem({
                object: 'product',
                action: 'edit',
                table: 'products',
                fields: { supplierId: this.account.supplierId, product: form }
            }).then((response) => {
                if(response && response.status == 200){
                    // Clear both selectedProduct and clonedProduct
                    this.clearSelectedItem();
                    this.flushEvents();
                    this.$router.push({ name: 'inventory' });
                }
            }).catch((response) => {

            });
        },
    },
    components: {
        Modal,
        scheduleGroupChanges,
    }
}
</script>

<style lang="scss">
    .saveProductChanges .modal-lg{
        max-width: 650px;
    }
</style>



// WEBPACK FOOTER //
// ProductSaveChanges.vue?e4189c6a